import { Button, ButtonProps, Link, LinkProps } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';

interface JobDetailsButtonProps extends Pick<ButtonProps, 'color' | 'size' | 'startIcon' | 'sx' | 'variant'> {
  jobId: string;
  children: React.ReactNode;
  returnToParentJobId?: string;
  ariaLabel?: string;
  title?: string;
}

export const JobDetailsLink: React.FC<{
  jobId: string;
  children?: React.ReactNode;
  color?: LinkProps['color'];
  variant?: LinkProps['variant'];
  title?: string;
  ariaLabel?: string;
  sx?: LinkProps['sx'];
}> = ({ jobId, children, color = 'inherit', variant, title, ariaLabel, sx }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  searchParams.set('jobDrawerOpen', '1');
  searchParams.set('currentJobId', jobId);

  return (
    <Link
      component={RouterLink}
      to={{ pathname: location.pathname, search: searchParams.toString() }}
      color={color}
      variant={variant}
      title={title}
      aria-label={ariaLabel}
      sx={sx}
      underline="hover"
    >
      {children || jobId}
    </Link>
  );
};

export const JobDetailsButton: React.FC<JobDetailsButtonProps> = ({
  jobId,
  children,
  returnToParentJobId,
  color = 'inherit',
  size = 'small',
  startIcon,
  sx,
  variant = 'text',
  title,
  ariaLabel,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const openJob = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('jobDrawerOpen', '1');
    searchParams.set('currentJobId', jobId);
    if (returnToParentJobId) {
      searchParams.set('jobParentId', returnToParentJobId);
    } else {
      searchParams.delete('jobParentId');
    }
    navigate({ pathname: location.pathname, search: searchParams.toString() });
  };

  return (
    <Button
      color={color}
      size={size}
      startIcon={startIcon}
      sx={sx}
      variant={variant}
      title={title}
      aria-label={ariaLabel}
      onClick={openJob}
    >
      {children}
    </Button>
  );
};
